export const URLS = {
  ersContactUsPage: 'https://ers-cat.com/contact',
};
